import React, { useContext, useState } from "react";
import { Box, Chip, Grid, Link, Paper, Typography } from "@mui/material";
import currency from "currency.js";
import Images from "../../request/components/Images";
import Invoices from "../component/Invoices";
import HTMLViewer from "../../common/component/HTMLViewer";
import ImageCarousel from "../../common/component/ImageCarousel";
import LineItemDetails from "../../common/component/lineitem/LineItemDetails";
import ItemProgress from "./ItemProgress";
import { getItemProgress } from "../../common/util";
import { UserContext } from "../../context/UserContext";

export default function OrderDetails(props) {
  const { order, onItemProgressChange } = props;
  const { user } = useContext(UserContext);
  const details = order.details;

  const [openDetails, setOpenDetails] = useState({});

  if (order.items) {
    return (
      <Paper elevation={0}>
        <Box px={2} py={2}>
          {order.items.map((item, idx) => {
            const progress =
              onItemProgressChange && getItemProgress(order, item, user?.config?.kds?.progressSteps);
            const showDetails = Boolean(openDetails[idx]);
            return (
              <Box key={idx} py={1} sx={{ display: "flex", gap: "10px", minWidth: 0 }}>
                <Box sx={{ width: "40px", flexShrink: 0 }}>
                  <ImageCarousel images={item.images} />
                </Box>
                <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                  <Typography variant="body1" noWrap>
                    {`${item.quantity || 1}x ${item.title || item.type}`}
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <Link
                      sx={{ cursor: "pointer", fontSize: ".9rem" }}
                      onClick={() => setOpenDetails((prev) => ({ ...prev, [idx]: !showDetails }))}
                    >
                      {showDetails ? "hide" : "show"} details
                    </Link>
                    {progress && (
                      <Box sx={{ display: "inline-flex", py: "4px" }}>
                        <ItemProgress
                          key={`${idx}-${progress.step}`}
                          orderId={order.id}
                          item={item}
                          itemIndex={idx}
                          progress={progress}
                          onChange={onItemProgressChange}
                          size={20}
                        />
                      </Box>
                    )}
                  </Box>
                  {showDetails && (
                    <Box sx={{ borderLeft: "2px solid #ECECEC", paddingLeft: "1rem" }}>
                      <LineItemDetails item={item} />
                    </Box>
                  )}
                </Box>
                <Box align="right" sx={{ minWidth: "4rem", flexShrink: 0 }}>
                  <Typography variant="overline">
                    {currency(item.total || item.price).format()}
                  </Typography>
                </Box>
              </Box>
            );
          })}
          {order.invoice && <Invoices order={order} />}
        </Box>
      </Paper>
    );
  } else {
    return (
      <Paper elevation={0}>
        <Box px={2} py={4}>
          <Grid container spacing={2}>
            <Grid item sm={4} xs={12}>
              <Images pics={details.pics} allowDownload={props.allowDownload} />
            </Grid>
            <Grid item sm={8} xs={12}>
              <Grid container spacing={1}>
                <Grid item sm={12} xs={12}>
                  <Typography variant="overline" color="textSecondary" display="block">
                    TITLE
                  </Typography>
                  <Typography variant="body2" display="block">
                    {details.title}
                  </Typography>
                </Grid>
                {details.size && (
                  <Grid item sm={6} xs={6}>
                    <Typography variant="overline" color="textSecondary" display="block">
                      SIZE
                    </Typography>
                    <Typography variant="body2" display="block">
                      {`${details.shape || ""} ${details.size}`}
                    </Typography>
                  </Grid>
                )}
                <Grid item sm={6} xs={6}>
                  <Typography variant="overline" color="textSecondary" display="block">
                    SERVINGS
                  </Typography>
                  <Typography variant="body2" display="block">
                    {details.servings || `Not specified`}
                  </Typography>
                </Grid>
                <Grid item sm={6} xs={6}>
                  <Typography variant="overline" color="textSecondary" display="block">
                    FLAVOR
                  </Typography>
                  <Typography variant="body2" display="block">
                    {details.flavor || `Not specified`}
                  </Typography>
                </Grid>
                <Grid item sm={6} xs={6}>
                  <Typography variant="overline" color="textSecondary" display="block">
                    FILLING
                  </Typography>
                  <Typography variant="body2" display="block">
                    {details.filling || `Not specified`}
                  </Typography>
                </Grid>
                <Grid item sm={6} xs={12}>
                  <Typography variant="overline" color="textSecondary" display="block">
                    FROSTING
                  </Typography>
                  <Typography variant="body2" display="block">
                    {details.frosting || `Not specified`}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="overline" color="textSecondary" display="block">
                    INSCRIPTION
                  </Typography>
                  <Typography variant="body2" display="block">
                    {details.inscription || `Not specified`}
                  </Typography>
                </Grid>
                {details.tags && details.tags.length > 0 && (
                  <Grid item xs={12}>
                    <Typography variant="overline" color="textSecondary" display="block">
                      TAGS
                    </Typography>
                    {details.tags.map((e, idx) => (
                      <Chip key={idx} size="small" label={e} />
                    ))}
                  </Grid>
                )}
                {details.decor && details.decor.length > 2 && (
                  <Grid item xs={12}>
                    <Typography variant="overline" color="textSecondary" display="block">
                      NOTES
                    </Typography>
                    <HTMLViewer content={details.decor} style={{ fontSize: ".85rem" }} />
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
          {order.invoice && <Invoices order={order} />}
        </Box>
      </Paper>
    );
  }
}
